import { useTranslation } from "react-i18next";
import "./DisclamerText.scss";

const DisclamerText = () => {
  const { t } = useTranslation("disclamer");

  return (
    <div className="disclamerContent topMargin">
      <div className="disclamer">{t("disclamertext")}</div>
    </div>
  );
};

export default DisclamerText;
